module.exports = __webpack_public_path__ + "img/29.dd3feddc.webp";